import { Button } from "primereact/button";
import { Rating } from "primereact/rating";
import React, { useState } from "react";

const clipLengths = [
  { label: "10s", value: "10s" },
  { label: "30s", value: "30s" },
  { label: "1m", value: "1m" },
  { label: "2m", value: "2m" },
  { label: "3m", value: "3m" },
];
const clipMoments = [
  { label: "Starting Point", value: "start" },
  { label: "Mid Point", value: "mid" },
  { label: "End Point", value: "end" },
];

export default function SaveBookmarkPopup({ setShowBookmarkPopup }) {
  const [ratingValue, setRatingValue] = useState(3);
  const [manualSeconds, setManualSeconds] = useState(null);
  const [clipLength, setClipLength] = useState("");
  const [clipMoment, setClipMoment] = useState("");
  const [tags, setTags] = useState("");
  const [notesValue, setNotesValue] = useState("");

  const handleSave = () => {
    let bookMarkPopupData = {
      tags,
      notesValue,
      ratingValue,
      clipLength: clipLength === "secs" ? `${manualSeconds}s` : clipLength,
      clipMoment,
    };

    setShowBookmarkPopup(false);
  };

  return (
    <div
      className="bg-dark text-white fs-12"
      style={{ maxWidth: "500px", padding: "8px 12px" }}
    >
      <div className="d-flex align-items-start gap-3">
        <div className="flex-fill w-50">
          {/* TAGS */}
          <div className="mb-3">
            <label className="form-label fw-bold">Tags</label>
            <input
              type="text"
              className="form-control"
              placeholder="separate with commas"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
            />
          </div>

          {/* NOTES */}
          <div className="mb-3">
            <label className="form-label fw-bold">Notes (Optional)</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="write a note here (optional)"
              value={notesValue}
              onChange={(e) => setNotesValue(e.target.value)}
            ></textarea>
          </div>
        </div>

        <div className="flex-fill w-50">
          {/* RATING */}
          <div className="mb-3">
            <label className="form-label fw-bold">Rating (Optional)</label>
            <Rating
              value={ratingValue}
              onChange={(e) => setRatingValue(e.value)}
              cancel={false}
              stars={5}
              color="red"
            />
          </div>

          {/* CLIP LENGTH */}
          <div className="mb-3">
            <label className="form-label fw-bold">Clip Length</label>
            <div className="d-flex align-items-center flex-wrap gap-3">
              {clipLengths.map((clipLen) => (
                <div className="form-check" key={clipLen.label}>
                  <input
                    className="form-check-input"
                    value={clipLen.value}
                    checked={clipLength === clipLen.value}
                    type="radio"
                    name="clipTime"
                    id={clipLen.label}
                    onChange={(e) => setClipLength(e.target.value)}
                  />
                  <label
                    className="form-check-label mt-1 ms-1"
                    htmlFor={clipLen}
                  >
                    {clipLen.label}
                  </label>
                </div>
              ))}

              <div className="form-check">
                <input
                  className="form-check-input"
                  value={"secs"}
                  checked={clipLength === "secs"}
                  type="radio"
                  name="clipTime"
                  onChange={(e) => setClipLength(e.target.value)}
                />
                <div className="d-flex align-items-center">
                  <span className="mx-1">secs</span>
                  <input
                    value={manualSeconds}
                    type="number"
                    className="form-control p-0"
                    style={{
                      width: "40px",
                      lineHeight: "14px",
                      borderRadius: "2px",
                    }}
                    onChange={(e) => setManualSeconds(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* CLIP THIS MOMENT AS */}
          <div className="mb-4">
            <label className="form-label fw-bold">Clip This Moment As</label>

            <div className="d-flex align-items-center flex-wrap gap-3">
              {clipMoments.map((clipMom) => (
                <div className="form-check" key={clipMom.label}>
                  <input
                    className="form-check-input"
                    value={clipMom.value}
                    checked={clipMoment === clipMom.value}
                    type="radio"
                    name="clipType"
                    id={clipMom.label}
                    onChange={(e) => setClipMoment(e.target.value)}
                  />
                  <label
                    className="form-check-label mt-1 ms-1"
                    htmlFor={clipMom}
                  >
                    {clipMom.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex-fill d-flex justify-content-end gap-3">
        <Button
          className="px-0 py-0 fw-600"
          style={{ color: "#fff" }}
          link
          onClick={() => setShowBookmarkPopup(false)}
        >
          Cancel
        </Button>
        <Button
          className="pe-3 py-0 fw-600"
          style={{ color: "#fff" }}
          link
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
